import { cva } from 'class-variance-authority';

/**
 * Hit target for a full-surface drop. The scrim sits on top of this with
 * `pointer-events-none`, so the drop lands here and react-dropzone validates it.
 */
export const fileDropSurfaceRootVariants = cva('z-50', {
  variants: {
    scope: {
      window: 'fixed inset-0',
      container: 'absolute inset-0',
    },
  },
  defaultVariants: {
    scope: 'window',
  },
});
